import { Injectable } from '@angular/core';
import { GungStringConverterService, Order, OrderService } from 'gung-standard';
import { first, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SjoborgOrderService extends OrderService {
  getOrdersWithTracking(customerId: string, trackingDaysBack?: number, nocache?: boolean): Observable<Order[]> {
    let url = `json/sjoborgs/orders/list/${GungStringConverterService.toGungString(customerId)}`;
    if (trackingDaysBack) {
      url += `?trackingDaysBack=${trackingDaysBack}`;
    }

    const headers = {
      maxAge: nocache ? '-1' : '300'
    };
    return this.http.get<Order[]>(url, { headers }).pipe(
      switchMap(orders => {
        if (orders.length === 0) {
          return of([]);
        }

        return this.customerService.getCustomer(customerId).pipe(
          first(),
          map(customer => orders.map(order => this.orderMapper(order, customer)))
        );
      })
    );
  }
}
